import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Slide,
} from '@mui/material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Loading from '../table-elements/loading.component';
import { CONTENT_ALIAS } from '../../config/const.config';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ListSequenceCategories = ({
  handleOnDragEndCategories,
  handleUpdateCategoriesSequence,
  action,
  selectedChannel,
  channelCategoriesList,
  catOptions,
  handleCloseDialog,
}) => (
  
  <Dialog
    open={action.show}
    aria-describedby="channel-category-videos"
    aria-labelledby="channel-category-videos"
    TransitionComponent={Transition}
    fullWidth
    maxWidth="md"
  >
    <DialogTitle>{`Reorder ${CONTENT_ALIAS.PODCAST_PLURAL} Sequence - ${selectedChannel.title}`}</DialogTitle>

    <DialogContent dividers>
      {catOptions.loading && <Loading />}

      {!catOptions.loading && (
        <DragDropContext onDragEnd={handleOnDragEndCategories}>
          <Droppable droppableId="videos">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {!catOptions.loading &&
                  channelCategoriesList.length > 0 &&
                  channelCategoriesList.map((video, index) => (
                    <Draggable
                      key={`video-${video.id}`}
                      draggableId={video.id.toString()}
                      index={index}
                    >
                      {(provide) => (
                        <Card
                          sx={{
                            marginBottom: '5px',
                          }}
                          ref={provide.innerRef}
                          {...provide.draggableProps}
                          {...provide.dragHandleProps}
                        >
                          <CardContent
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              paddingY: '12px',
                              '&:last-child': {
                                paddingBottom: '12px',
                              },
                            }}
                          >
                            <div>{video.title || video.name}</div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            />
                          </CardContent>
                        </Card>
                      )}
                    </Draggable>
                  ))}

                {!catOptions.loading && channelCategoriesList.length === 0 && (
                  <Paper
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    No data available.
                  </Paper>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </DialogContent>

    <DialogActions>
      <Button
        onClick={handleUpdateCategoriesSequence}
        disabled={
          channelCategoriesList.length === 0 || channelCategoriesList.length === 1
        }
        variant="contained"
      >
        Save
      </Button>
      <Button onClick={handleCloseDialog} variant="contained">Cancel</Button>
    </DialogActions>
  </Dialog>
);

ListSequenceCategories.propTypes = {
  handleOnDragEndCategories: PropTypes.func.isRequired,
  handleUpdateCategoriesSequence: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  selectedChannel: PropTypes.object.isRequired,
  channelCategoriesList: PropTypes.array.isRequired,
  catOptions: PropTypes.object.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

export default ListSequenceCategories;
